import { lumi } from '../lib/lumi'

export const useAdminLog = () => {
  const logAction = async (
    action: string,
    entityType: string,
    entityId: string,
    details?: string
  ) => {
    try {
      const user = lumi.auth.user
      
      if (!user) {
        console.error('No authenticated user for logging')
        return
      }

      await lumi.entities.admin_logs.create({
        adminId: user.userId,
        adminName: user.userName || user.email,
        action,
        entityType,
        entityId,
        details: details || '',
        creator: user.userId,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      })
    } catch (error) {
      console.error('Failed to log admin action:', error)
    }
  }

  return { logAction }
}